import { render, staticRenderFns } from "./TPSHome.vue?vue&type=template&id=1cb6c220&"
import script from "./TPSHome.vue?vue&type=script&lang=js&"
export * from "./TPSHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports